module.exports = __webpack_public_path__ + "static/media/torso-top-front.fdb7ddb0.png";